import { Briefcase, Code2, Globe, Rocket, Users } from "lucide-react";

const STATS = [
    { value: "20+", label: "années d'expertise terrain" },
    { value: "3", label: "SaaS dans la suite" },
    { value: "30-40", label: "sites livrés / an par Karedess" },
    { value: "100%", label: "créés en agence, pour des agences" },
];

const LOGOS = [
    { name: "Local SEO", icon: Globe },
    { name: "SMS Avis", icon: Users },
    { name: "PleskDash", icon: Code2 },
    { name: "Karedess Agency", icon: Briefcase },
    { name: "Bientôt", icon: Rocket },
];

export default function TrustBar() {
    return (
        <section className="relative border-y border-border bg-card/30 py-12">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <p className="text-center font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
                    L'écosystème Web Me Up en chiffres
                </p>
                <div className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-border bg-border lg:grid-cols-4">
                    {STATS.map((s) => (
                        <div key={s.label} className="bg-background p-6 text-center sm:p-8">
                            <div className="font-display text-3xl font-semibold text-gradient sm:text-4xl">{s.value}</div>
                            <div className="mt-1.5 text-xs text-muted-foreground sm:text-sm">{s.label}</div>
                        </div>
                    ))}
                </div>

                <div className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 opacity-80">
                    {LOGOS.map((l) => (
                        <div key={l.name} className="inline-flex items-center gap-2 text-muted-foreground">
                            <l.icon className="h-4 w-4" />
                            <span className="font-display text-sm font-medium">{l.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
